import {BrowserRouter, Route, Routes} from "react-router-dom";
import Error from "./Components/Error";
import {UserInfoContextProvider} from "./Contexts/UserInfoContext";
import {useEffect} from "react";
import {getAllPathsForRouteKey, getExternalRedirects, getRoutes, ROUTE_KEYS} from "./routes/definitions";

function ExternalRedirect({url}) {
    useEffect(() => {
        window.location.replace(url);
    }, [url]);

    return null;
}

export default function App() {
    const routes = getRoutes();
    const externalRedirects = getExternalRedirects();
    const externalRedirectPaths = new Set(externalRedirects.map(({path}) => path));
    const notFoundElement =
        routes.find((route) => route.key === ROUTE_KEYS.ERROR_404)?.getElement() ?? <Error type="404"/>;

    return (
        <BrowserRouter>
                <UserInfoContextProvider>
                    <Routes>
                        {externalRedirects.map(({path, url}) => (
                            <Route key={`external-redirect-${path}`} path={path} element={<ExternalRedirect url={url}/>}/>
                        ))}
                        {routes.flatMap((route) =>
                            getAllPathsForRouteKey(route.key).filter((path) => !externalRedirectPaths.has(path)).map((path) => (
                                <Route key={`${route.key}-${path}`} path={path} element={route.getElement()}/>
                            ))
                        )}
                        <Route path="*" element={notFoundElement}/>
                    </Routes>
                </UserInfoContextProvider>
        </BrowserRouter>
    );
}

